import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { CreditAgreementSectionWipContainer } from 'capitalProvider/domains/credit-agreements/ui/CreditAgreementWip';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import 'source/borrower/borrower.scss';
import { useQueryParams } from 'packages/common-frontend/hooks/useQueryParams';
import { creditFacilityIdQueryParam } from 'packages/credit-facility/ui/CreditFacilitySelect';

export const SettingsFacilityPortfolioCovenantsEditRoute = () => {
  const toast = useToast();
  const history = useHistory();

  const query = useQueryParams();
  const creditFacilityId = query.get(creditFacilityIdQueryParam);

  if (!creditFacilityId) {
    history.push('/settings/facilities');
    toast({
      ...errorToastConfig,
      id: 'errorLoadSettingsFacilityPortfolioCovenants',
      title: 'Please select a credit facility.',
    });
    return null;
  }

  let routeLevelError = false;
  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load settings facility portfolio covenants edit page`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/');
          }
        }}
      >
        <CreditAgreementSectionWipContainer
          creditFacilityId={creditFacilityId}
          section="portfolioCovenants"
          isEditOnlyMode
        />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
